import useChatActions from '@src/hooks/useChatActions';
import { deleteChatAction } from '@src/reducers/chats';
import {
  activeChatSelector,
  chatActivationActionSelector,
  chatCloseActionSelector,
  chatExportCrmActionSelector,
  chatPickupActionSelector,
} from '@src/selectors/chats';
import { ChatActionsStatus } from '@src/types/chats';
import { connect } from 'react-redux';
import ActiveChat from './ActiveChat';

// Maps the state of the store to a set of props that will provide the presentational component with part of the state
const mapStateToProps = state => {
  // Indicate if the active chat is currently being switched, to either a chat request or an on-going chat
  let isAwaitingActiveChatSwitch = false;
  let isAwaitingActiveChatClose = false;
  let lastChatCloseError = null;
  let lastChatCrmExportError = null;
  let agentId = null;

  const chatPickupAction = chatPickupActionSelector(state);
  const chatExportCrmAction = chatExportCrmActionSelector(state);
  const chatActivationAction = chatActivationActionSelector(state);
  const chatCloseAction = chatCloseActionSelector(state);

  if (state.loginAuthentication.success) {
    agentId = state.loginAuthentication.success.id;
  }

  if (
    chatPickupAction?.status === ChatActionsStatus.AWAIT ||
    chatActivationAction?.status === ChatActionsStatus.AWAIT
  ) {
    isAwaitingActiveChatSwitch = true;
  }

  if (chatCloseAction?.status === ChatActionsStatus.AWAIT) {
    isAwaitingActiveChatClose = true;
  }

  if (chatCloseAction?.status === ChatActionsStatus.FAILURE) {
    lastChatCloseError = chatCloseAction.details;
  }

  if (chatExportCrmAction?.status === ChatActionsStatus.FAILURE) {
    lastChatCrmExportError = chatExportCrmAction.details;
  }

  // Note that the activeChatHistory attribute is set here just to force the ActiveChat component
  // to be rendered any time the history of the currently active chat is re-loaded
  const activeChat = activeChatSelector(state);

  return {
    activeChat,
    chatXferRequest: activeChat?.chatXferRequest,
    agentId,
    isAwaitingActiveChatSwitch,
    isAwaitingActiveChatClose,
    lastChatCloseError,
    lastChatCrmExportError,
    loadedImagesErrors: state.errors?.loadedImagesErrors || [],
    isOpenList: state.chatViewer.showDepartmentList,
  };
};

// Maps the action creators to a set of props that will be passed as functions to the presentational component
const mapDispatchToProps = {
  onAcknowledgeLastChatCloseError: deleteChatAction,
  onAcknowledgeLastChatCrmExportError: deleteChatAction,
};

// This is a container component. It owns the state of the ActiveChat presentational component
const ActiveChatContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {}
)(props => {
  const { acceptChatTransfer, cancelChatTransfer, rejectChatTransfer } =
    useChatActions();
  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <ActiveChat
      onAcceptAgentChatTransfer={acceptChatTransfer}
      onCancelAgentChatTransfer={cancelChatTransfer}
      onRejectAgentChatTransfer={rejectChatTransfer}
      {...props}
    />
  );
});

export default ActiveChatContainer;
